// import { useNavigate } from 'react-router-dom'
// import BePartner from '../BePartner';

// import ac from "./image/ac.jpeg"
// import clean from '../video/bgsaf.avif'
// import paint from '../video/paintbg1.avif'
// import plum from "../video/plumbg.avif"
// import Review from '../Review';
// import '../newservice/master1.css'
// import FaqAll from './FaqAll';
// const imgSt = {
//   backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${ac})`,
//   backgroundSize: 'cover',
//   backgroundPosition: 'center',
//   color: 'white',
//   textAlign: 'center',
//   padding: '60px 20px',
// };
// const plumber={
//     backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${plum})`,

// }

// const Style = {
//   backgroundSize: 'cover',
//   backgroundPosition:'center',
//   display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//   color: 'white',
//   textAlign: 'center',
//   padding: '60px 20px',
// };

// const plumberStyle={
//   ...plumber,
//   ...Style,
// }
// const cleaning={
//   ...Style,
//       backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${clean})`,

// }
// const painting={
//   ...Style,
//       backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${paint})`,

// }
// export default function Master1() {
//     const navigate=useNavigate();
//   return (
    
// <div
//       className="min-vh-100 d-flex flex-column align-items-center justify-content-center text-light hero-bg"
//       // style={{
//       //  background: 'linear-gradient(135deg, rgba(111, 0, 255, 0.99), rgb(24, 200, 223), rgb(0, 0, 0))',
//       //   padding: '3rem 1rem',
//       // }}
// // style={bg}
//     >
//       <div className="container" >
//         <header className="text-center mb-5">
//           <h1 className="display-4 fw-bold">🏠 One-Stop Home Service Experts</h1>
//           <p className="lead">Appliance Repair, Painting, Plumbing & Cleaning — Done Right.</p>
//         </header>

//         <div className="row gy-4">
//           {/* Appliance Repair */}
//           <div className="col-md-6">
//             <div className="card shadow h-100" >
//                <div className="card-body text-white"  /*style={{
//        background: 'linear-gradient(135deg, rgba(0, 204, 255, 0.99), rgb(25, 177, 247), rgb(11, 184, 170))',
//         padding: '3rem 1rem',
//       }}> */
//       style={imgSt}
//       >
//                 <h3 className="card-title">🔧 Appliance Repair</h3>
//                 <p>Quick fixes for all your essential appliances, from washing machines to fridges.</p>
//                 <ul>
//                   <li>Certified technicians</li>
//                   <li>Same-day service</li>
//                   <li>Genuine spare parts</li>
//                   <li>Transparent pricing</li>
//                 </ul>
//                 <button className="btn btn-dark" onClick={() => navigate('/contact')}>Book Machanic</button>
//               </div>
//             </div>
//           </div>

// {/* Web Development */}
// <div className="col-md-6">
//   <div className="card shadow h-100">
//     <div
//       className="card-body text-white"
//       style={{
//         background: 'linear-gradient(135deg, #007bff, #5c8df7, #3b57c8)',
//         padding: '3rem 1rem',
//       }}
//     >
//       <h3 className="card-title">💻 Web Development</h3>
//       <p>Custom websites and apps tailored to your brand and business goals.</p>
//       <ul>
//         <li>Responsive design (React + Bootstrap)</li>
//         <li>Backend APIs with Node/Express</li>
//         <li>Full-stack integration</li>
//         <li>SEO & performance optimized</li>
//       </ul>
//       <button className="btn btn-dark" onClick={() => navigate('/contact')}>
//         Book Developer
//       </button>
//     </div>
//   </div>
// </div>


//           {/* Painting */}
//           <div className="col-md-6">
//             <div className="card shadow h-100" /*style={{
//        background: 'linear-gradient(135deg, rgba(0, 204, 255, 0.99), rgb(25, 195, 247), rgb(11, 184, 170))',
//         padding: '3rem 1rem',
//       }}> */
// style={painting}
//       >
//               <div className="card-body text-white">
//                 <h3 className="card-title">🎨 Home Painting</h3>
//                 <p>Refresh your space with crisp, clean painting — inside and out.</p>
//                 <ul>
//                   <li>Interior & exterior services</li>
//                   <li>Eco-friendly options</li>
//                   <li>Color consultation</li>
//                   <li>Prep & patch included</li>
//                 </ul>
//                 <button className="btn btn-dark" onClick={() => navigate('/contact')}>Book Painter</button>
//               </div>
//             </div>
//           </div>

//           {/* Plumbing */}
//           <div className="col-md-6">
//              <div className="card shadow h-100" /* style={{
//        background: 'linear-gradient(135deg, rgba(0, 204, 255, 0.99), rgb(25, 214, 247), rgb(10, 218, 200))',
//         padding: '3rem 1rem',
//       }}> */
// style={plumberStyle}
//       >
//               <div className="card-body text-white">
//                 <h3 className="card-title">🚰 Plumbing Services</h3>
//                 <p>We handle everything from leaks to full installations — fast and professional.</p>
//                 <ul>
//                   <li>Leak repair & detection</li>
//                   <li>Drain cleaning</li>
//                   <li>Fixture installs</li>
//                   <li>Emergency support</li>
//                 </ul>
//                 <button className="btn btn-dark text-white" onClick={() => navigate('/contact')}>Book a Plumber</button>
//               </div>
//             </div>
//           </div>

//           {/* Cleaning */}
//           <div className="col-md-6">
//              <div className="card shadow h-100" /* style={{
//        background: 'linear-gradient(135deg, rgba(0, 140, 255, 0.89), rgb(25, 232, 247), rgb(8, 219, 131))',
//         padding: '3rem 1rem',
//       }}> */
// style={cleaning}
//       >
//               <div className="card-body text-white">
//                 <h3 className="card-title">🧼 Home Cleaning</h3>
//                 <p>Enjoy a spotless space with one-time deep cleans or regular service.</p>
//                 <ul>
//                   <li>Detailed room cleaning</li>
//                   <li>Appliance & carpet care</li>
//                   <li>Move-in/move-out cleaning</li>
//                   <li>Flexible packages</li>
//                 </ul>
//                 <button className="btn btn-dark" onClick={() => navigate('/contact')}>Book Cleaning</button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Why Choose Us */}
//         <section className="text-center mt-5">
//           <h2 className="mb-3">💬 Why Choose Us?</h2>
//           <div className="row justify-content-center">
//             <div className="col-md-8">
//               <ul className="list-group list-group-flush bg-transparent text-white">
//                 <li className="list-group-item bg-transparent border-0 text-white">✔️ Trusted Professionals</li>
//                 <li className="list-group-item bg-transparent border-0 text-white">✔️ Upfront Pricing</li>
//                 <li className="list-group-item bg-transparent border-0 text-white">✔️ Flexible Scheduling</li>
//                 <li className="list-group-item bg-transparent border-0 text-white">✔️ 100% Satisfaction Guarantee</li>
//               </ul>
//             </div>
//           </div>
//         </section>

//         {/* Call to Action */}
//         <footer className="text-center mt-5">
//           <h3>📅 Book Your Service Today!</h3>
//           <p>Call us at <strong>9199245536</strong> or click below to schedule online.</p>
//           <button className="btn btn-dark btn-lg" onClick={() => navigate('/contact')}>Book Now</button>
//         </footer>
//         <BePartner></BePartner>
//       <Review></Review>
//       <FaqAll></FaqAll>
//       </div>
//     </div>

//   )
// }



import { useEffect,useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import BePartner from '../BePartner';
import Review from '../Review';
import FaqAll from './FaqAll';
import './master1.css';
import ac from "./image/ac.jpeg"
import clean from '../video/bgsaf.avif'
import paint from '../video/paintbg1.avif'
import plum from "../video/plumbg.avif"
import dev from "../video/dev.jpg"
import '../newservice/master1.css'
const devlop = {
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${dev})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: 'white',
  textAlign: 'center',
};
const imgSt = {
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${ac})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: 'white',
  textAlign: 'center',
};
const paintbg1= {
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${paint})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: 'white',
  textAlign: 'center',
};
const plumber={
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${plum})`,

}
const safai= {
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${clean})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: 'white',
  textAlign: 'center',
};

const Style = {
  backgroundSize: 'cover',
  backgroundPosition:'center',
  display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  color: 'white',
  textAlign: 'center',
  padding: '60px 20px',
};
export default function Master1() {
  const navigate = useNavigate();


 const [formData, setFormData] = useState({
      name: "",
    phone: "",
    email: "",
    message: "",
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log("Form submitted:", formData)
    fetch("https://portfolioback-nu.vercel.app/accontact", {
  
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    alert("Form submitted successfully!")
    setFormData({ name: "",email: "",phone: "", message: "" })
  }


  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center text-light hero-bg">
      
      
      <main>
        <section className="hero hero-bg">
          <h1 className="text-center mb-5 text-white">Welcome To OneStop Home Services & Web Development</h1>
          <div className="container-fluid">
            
            <div className="hero-content">
              
              {/* <h2 >ONE STOP SERVICE & Web Development</h2> */}
     <h2 className=" mb-3 fw-semibold text-warning" >From code to Home Services — we’ve got it covered</h2>

              <h1 className="text-warning">At your Siwan,Bihar</h1>
              <div className="course-features">
                <p style={{color:'InfoBackground'}}>
   We bring expert home services and digital solutions right to your doorstep. 
   From refreshing your space with
    a new coat of paint, deep-cleaning your home, fixing appliances, and solving
     plumbing issues, to building a stunning website, crafting engaging digital experiences, and boosting your online presence - we've got you covered. Our trusted professionals are committed to delivering top-quality work, on time, and with your satisfaction in mind. Let us handle the hard work, so you can enjoy a hassle-free, beautifully maintained home and a thriving online presence."


                </p>
              </div>
            </div>
            <div className="enrollment-form">
              <h3>Your Query in Our Servic</h3>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Your Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="tel"
                  placeholder="Your Number"
                  name="number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  placeholder="Your Email Id"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <textarea
                  placeholder="Comment or Message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </section>


       

      </main>
      
      <div className="container" >
        {/* Main Header */}
        <header className="text-center mb-5" data-aos="fade-up">
          <h1 className="display-4 fw-bold m-2" style={{color:'#d4af37'}} data-aos="zoom-in">One-Stop-Service Experts</h1>
     <p className="lead text-dark" data-aos="zoom-in">
            We connect you with certified professionals who deliver quality and satisfaction, whether it's fixing your appliances or building your online presence.
          </p>
     <p className="lead text-dark text-center text-md-start" data-aos="zoom-in">
  <strong>Web Development</strong>, <strong>Appliance Repair</strong>, <strong>Painting</strong>, <strong>Plumbing</strong> & <strong>Cleaning</strong> — Done Right.
  <br className="d-none d-md-block" />
  From <em>home essentials to digital solutions</em>, OneStopService delivers <strong>fast</strong>, <strong>reliable</strong>, and <strong>affordable</strong> services tailored to your needs.
  <br /><br />
  Our experienced professionals combine <strong>technology</strong> and <strong>craftsmanship</strong> to make life easier — one service at a time.
</p>
        </header>

        {/* Intro Section */}
        <section className="mb-5  text-center" data-aos="fade-up">
          {/* <h2 className=" mb-3 fw-semibold" style={{color:'#d4af37'}}>Reliable Services for Every Need</h2> */}
                   <h2 className=" mb-3 fw-semibold" style={{color:'#d4af37'}}>From code to Home Services — we’ve got it covered</h2>
<div className='  text-dark'>
     <p>
            Founded in 2024, <strong className='text-primary'>One Stop Service</strong> began as a specialized appliance repair company. Built on a foundation of trust, 
            efficiency, and customer satisfaction, we quickly earned a reputation for reliability and quality work.
          </p>
          <p>
            As we listened to our customers’ needs, we expanded into a full-service home and lifestyle support provider. Our offerings now include 
            <strong className='text-primary'> plumbing, painting, deep cleaning, electrical work</strong>, and most recently, <strong className='text-primary'>professional web development</strong>.
          </p>
          <p data-aos="zoom-in">
            In today’s world, homes and businesses don't just exist in the physical space — they live online too. Our decision to branch into web development
            was fueled by a desire to support small businesses, freelancers, and startups in building their online presence with the same
            dedication we apply to our home services.
          </p>
          
 <h2 className=' rounded text-center' style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>Our Vision</h2>
         

         
          <p data-aos="flip-left">
            Our vision is to become the most trusted name for both home improvement and digital growth services. Whether it's repairing what's broken,
            refreshing your space, or launching your online business — we aim to be your all-in-one solution partner.
          </p>
          </div>
        </section>
<div className="row gy-4">
   <h2 className=' rounded text-center' style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>Our Services</h2>

 {/* Web Development */}
          <div className="col-md-6" data-aos="fade-down" >
            <div className="card shadow h-100" style={devlop}>
              <div className="card-body service-card card-purple">
                <h3 className="card-title" data-icon="💻" style={{color:'yellow'}}>Web Development</h3>
                <p>Custom websites and apps tailored to your brand and business goals.</p>
                <ul className='text-warning' data-aos="slide-up" >
                  <li>Responsive design</li>
                  <li>Backend API</li>
                  <li>Full-stack integration</li>
                  <li>SEO & performance optimized</li>
                </ul>
                <button data-aos="slide-up"  className="btn btn-success" onClick={() => navigate('/contact')}>
                  Book Developer
                </button>
              </div>
            </div>
          </div>


          {/* Appliance Repair */}
          <div className="col-md-6" data-aos="zoom-in" >
            <div className="card shadow h-100" style={imgSt}>
              <div className="card-body service-card card-blue">
                <h3 className="card-title" data-icon="🔧" style={{color:'yellow'}}>Appliance Repair</h3>
                <p>Quick fixes for all your essential appliances, from washing machines to fridges.</p>
                <ul className='text-warning' data-aos="slide-up" >
                  <li>Certified technicians</li>
                  <li>Same-day service</li>
                  <li>Genuine spare parts</li>
                  <li>Transparent pricing</li>
                </ul>
                <button data-aos="slide-down"  className="btn btn-success" onClick={() => navigate('/contact')}>
                  Book Mechanic
                </button>
              </div>
            </div>
          </div>

         

          {/* Painting */}
          <div className="col-md-6" data-aos="zoom-in" >
            <div className="card shadow h-100" style={paintbg1}>
              <div className="card-body service-card card-orange">
                <h3 className="card-title" data-icon="🎨" style={{color:'yellow'}}>Home Painting</h3>
                <p>Refresh your space with crisp, clean painting — inside and out.</p>
                <ul className='text-warning' data-aos="slide-up" >
                  <li>Interior & exterior services</li>
                  <li>Eco-friendly options</li>
                  <li>Color consultation</li>
                  <li>Prep & patch included</li>
                </ul>
                <button data-aos="slide-up"  className="btn btn-success" onClick={() => navigate('/contact')}>
                  Book Painter
                </button>
              </div>
            </div>
          </div>

          {/* Plumbing */}
          <div className="col-md-6" data-aos="flip-left" >
            <div className="card shadow h-100" style={plumber}>
              <div className="card-body service-card card-teal" style={plumber}>
                <h3 className="card-title" data-icon="🚰" style={{color:'yellow'}}>Plumbing Services</h3>
                <p>We handle everything from leaks to full installations — fast and professional.</p>
                <ul className='text-warning' data-aos="slide-up" >
                  <li>Leak repair & detection</li>
                  <li>Drain cleaning</li>
                  <li>Fixture installs</li>
                  <li>Emergency support</li>
                </ul>
                <button data-aos="slide-down"  className="btn btn-success" onClick={() => navigate('/contact')}>
                  Book a Plumber
                </button>
              </div>
            </div>
          </div>

          {/* Cleaning */}
          <div className="col-md-6" data-aos="slide-up" >
            <div className="card shadow h-100" style={safai}>
              <div className="card-body service-card card-green">
                <h3 className="card-title" data-icon="🧼" style={{color:'yellow'}}>Home Cleaning</h3>
                <p>Enjoy a spotless space with one-time deep cleans or regular service.</p>
                <ul className='text-warning' data-aos="slide-down" >
                  <li>Detailed room cleaning</li>
                  <li>Appliance & carpet care</li>
                  <li>Move-in / Move-out cleaning</li>
                  <li>Carpet & upholstery cleaning</li>
                  <li>Window cleaning</li>
                  <li>Flexible packages</li>
                </ul>
                <button data-aos="slide-up"  className="btn btn-success" onClick={() => navigate('/contact')}>
                  Book Cleaning
                </button>
              </div>
            </div>
          </div>
        </div>


        
        {/* Highlight Section */}
        <section className=" py-5 rounded mt-5" data-aos="fade-right">
          <div className="container text-center">
            <h3 className=" mb-3" style={{color:'#d4af37'}}>You're In Good Hands</h3>
           <p className="text-dark mb-4">
  With <strong className='text-primary'>1+ years of hands-on experience</strong>, our team is <em>certified,
     background-verified, and customer-rated</em> to deliver high-quality service
      every time.
  We pride ourselves on our <strong className='text-primary'>attention to detail</strong>, <strong className='text-primary'>timely 
    delivery</strong>, and <strong className='text-primary'>genuine customer care</strong>. Whether it’s 
    fixing a home appliance, launching your website, or refreshing your space —
     we make it seamless, safe, and stress-free.
  <br /><br />
  Trusted by <strong>30+ happy clients</strong> and backed by a <strong className='text-primary'>4.9★ average rating</strong>, OneStopService is your reliable partner for getting things done — the right way.
</p>
          </div>
        </section>


<h2 className=" text-center my-5" style={{color:'#d4af37'}}>How It Works</h2>
<div className="row text-center">
  <div className="col-md-4 text-dark">
    <h5 className='text-primary'>1. Choose a Service</h5>
    <p>Select from our wide range of professional services.</p>
  </div>
  <div className="col-md-4 text-dark">
    <h5 className='text-primary'>2. Schedule Online</h5>
    <p>Pick a convenient time. We offer same-day slots.</p>
  </div>
  <div className="col-md-4 text-dark">
    <h5 className='text-primary'>3. Relax</h5>
    <p>Our team will take care of the rest — hassle-free.</p>
  </div>
</div>



        {/* Why Choose Us */}
<section className="py-5">
      <div className="container">
        <h2 className="text-center mb-4 fw-bold" style={{color:'#d4af37'}}>Why Choose Us</h2>
        <p className="text-center text-muted mb-5">
          One trusted team for all your digital and home service needs.
        </p>

        <div className="row g-4">
          {/* Web Development */}
          <div className="col-md-4">
            <div className="bg-white text-center p-4 shadow rounded h-100">
              <i className="bi bi-laptop-code fs-1 text-primary mb-3"></i>
              <h5 className="fw-semibold" style={{color:'#d4af37'}}>Smart Digital Solutions</h5>
              <p className="text-muted">
                From modern websites to custom apps — our web development team builds tools that grow your business.
              </p>
            </div>
          </div>

          {/* Home Painting */}
          <div className="col-md-4">
            <div className="bg-white text-center p-4 shadow rounded h-100">
              <i className="bi bi-paint-bucket fs-1 text-primary mb-3"></i>
              <h5 className="fw-semibold" style={{color:'#d4af37'}}>Professional Painting</h5>
              <p className="text-muted">
                Brighten your home with expert interior & exterior painting — fast, clean, and beautifully finished.
              </p>
            </div>
          </div>

          {/* Appliance Repairs */}
          <div className="col-md-4">
            <div className="bg-white text-center p-4 shadow rounded h-100">
              <i className="bi bi-tools fs-1 text-primary mb-3"></i>
              <h5 className="fw-semibold" style={{color:'#d4af37'}}>Appliance Repairs</h5>
              <p className="text-muted">
                Get quick fixes for washing machines, fridges, AC units and more — all from certified technicians.
              </p>
            </div>
          </div>

          {/* Plumbing */}
          <div className="col-md-4">
            <div className="bg-white text-center p-4 shadow rounded h-100">
              <i className="bi bi-droplet-half fs-1 text-primary mb-3"></i>
              <h5 className="fw-semibold" style={{color:'#d4af37'}}>Reliable Plumbing</h5>
              <p className="text-muted">
                Leaks, blocks, or installations — we provide efficient and affordable plumbing services you can trust.
              </p>
            </div>
          </div>

          {/* Cleaning */}
          <div className="col-md-4">
            <div className="bg-white text-center p-4 shadow rounded h-100">
              <i className="bi bi-broom fs-1 text-primary mb-3"></i>
              <h5 className="fw-semibold" style={{color:'#d4af37'}}>Deep Home Cleaning</h5>
              <p className="text-muted">
                From kitchens to carpets, our cleaning pros leave your home spotless, hygienic, and fresh.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>




        
        {/* <section className="text-center mt-5" data-aos="fade-up">
          <h2 className="mb-3 " style={{color:'#d4af37'}}>Why Choose Us?</h2>
          <div className="row justify-content-center">
            <div className="col-md-8">
              <ul className="list-group list-group-flush bg-transparent text-white">
                <li className="list-group-item bg-transparent border-0 text-dark">✔️ Trusted Professionals</li>
                <li className="list-group-item bg-transparent border-0 text-dark">✔️ Upfront Pricing</li>
                <li className="list-group-item bg-transparent border-0 text-dark">✔️ Flexible Scheduling</li>
                <li className="list-group-item bg-transparent border-0 text-dark">✔️ 100% Satisfaction Guarantee</li>
              </ul>
            </div>
          </div>
        </section> */}

        {/* Call to Action */}
        <footer className="text-center mt-5 p-4 text-dark rounded" data-aos="zoom-in-up">
          <h3 className="mb-2" style={{color:'#d4af37'}}>📅 Book Your Service Today!</h3>
          <p className="mb-3">
            Call us at <strong>9199245536</strong> or click below to schedule online.
          </p>
          <button className="btn btn-light btn-lg" onClick={() => navigate('/contact')}>
            Book Now
          </button>
        </footer>

        <BePartner />
        <Review />
        <FaqAll />
      </div>
    </div>
  );
}
